import { defineMessages } from 'react-intl';

export const messages: {
    title: {
        id: string;
        defaultMessage: string;
        description: string;
    }; totalCollaboratorsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; totalCollaboratorsDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    }; sharedItemsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; collaborationScoreLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; loadCollaboratorsError: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	title: {
		id: 'twg-microsite-experience.v2.collaborators.title',
		defaultMessage: 'Your collaborators',
		description: 'Heading for the collaborators section',
	},
	totalCollaboratorsLabel: {
		id: 'twg-microsite-experience.v2.collaborators.totalCollaboratorsLabel',
		defaultMessage: 'Total collaborators',
		description: 'Label beneath the large total collaborators number',
	},
	totalCollaboratorsDescription: {
		id: 'twg-microsite-experience.v2.collaborators.totalCollaboratorsDescription',
		defaultMessage:
			'Everyone you worked with over the last 12 months. Every collaboration, comment, mention, review, remembered by your Teamwork Graph to build better context.',
		description: 'Description for the total collaborators section',
	},
	sharedItemsLabel: {
		id: 'twg-microsite-experience.v2.collaborators.sharedItemsLabel',
		defaultMessage: '{count} shared items',
		description: 'Number of shared items with a collaborator',
	},
	collaborationScoreLabel: {
		id: 'twg-microsite-experience.v2.collaborators.collaborationScoreLabel',
		defaultMessage: 'Collaboration score',
		description: 'Collaboration score for a collaborator',
	},
	loadCollaboratorsError: {
		id: 'twg-microsite-experience.v2.collaborators.loadCollaboratorsError',
		defaultMessage: 'Error loading collaboration users',
		description: 'Error message shown when the list of top collaborators fails to load',
	},
});
